<template>
    <div>
        <div v-if="adType === 'Display'">
            <div v-if="width && height">
                <ins 
                    class="adsbygoogle"
                    :style="{display:'inline-block', width: width+'px',height: height+'px'}"
                    :data-ad-client="googleAdId"
                    :data-ad-slot="adSlot">
                </ins> 
            </div>
            <div v-else>
                <ins 
                    class="adsbygoogle"
                    style="display:block"
                    :data-ad-client="googleAdId"
                    :data-ad-slot="adSlot"
                    data-ad-format="auto"
                    data-full-width-responsive="true">
                </ins> 
            </div>  
        </div>   
        <div v-if="adType === 'InArticle'">
            <ins class="adsbygoogle"
                style="display:block; text-align:center;"
                data-ad-layout="in-article"
                data-ad-format="fluid"
                :data-ad-client="googleAdId"
                :data-ad-slot="adSlot"></ins>
        </div> 
    </div>
 </template>

<script>
    export default {
        name: "GoogleAd",
        props: {
            timeout: Number,
            adSlot: String,
            width: Number,
            height: Number,
            adType: { type: String, default: "Display"}
        },
        data() {
            return {
                googleInit: null,
                googleAdId: "ca-pub-3944671540352570"
            };
        },
        mounted() {
            let timeout = 2000;
            if(this.timeout) timeout = this.timeout;
            this.googleInit = setTimeout(() => {
            if (typeof window !== "undefined")
                (adsbygoogle = window.adsbygoogle || []).push({});
            }, timeout);
        },
        destroyed() {
            if (this.googleInit) clearTimeout(this.googleInit);
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/GoogleAdSense.vue